<template>
    <div>
        <!-- <div class="top-btn" > 
            <el-button type="primary" class="medical-btn" @click="batch_analysis('analysis_add')">批量加入分析池</el-button>
            <el-button type="primary" plain class="medical-btn" @click="batch_analysis('analysis_cancel')">批量取消加入分析池</el-button>
            <el-button type="primary" class="medical-btn" @click="batch_favorites('favorites_add')">批量加入收藏夹</el-button>
                <el-button type="primary" plain class="medical-btn" @click="batch_favorites('favorites_cancel')">批量取消加入收藏夹</el-button>
        </div> -->
        <div class="info-table">
            <el-table
                v-loading="medicalLoading"
                style="width: 100%;"
                :header-cell-style="{background:'#409EFF',color:'#fff',}"
                :data="tableList" 
                @selection-change="selectChange"
            >
                <!-- <el-table-column type="selection" width="50" > </el-table-column>
                    <el-table-column
                    label="序号"
                    width="50"
                    type="index"  
                >
                </el-table-column> -->
                <el-table-column 
                    label="医案原文" 
                    prop="medicaltext"
                >
                    <template slot-scope="scope"> 
                        <!-- <p class="text-overflow2 table-title">{{scope.row.title}} </p>  -->
                        <a href="javascript:;" @click='toDetails(scope.row)' class=" table-title">{{scope.row.medicaltext}} </a>
                    </template>
                </el-table-column>
                <el-table-column
                    label="来源"
                    prop="source" 
                    width='200'
                >
                    <template slot-scope="scope">
                        <p class="text-overflow3">{{scope.row.source}}</p> 
                    </template>
                </el-table-column>
                <!-- <el-table-column
                    label="点击次数"
                    prop="clickNum"
                    width="100"
                >
                </el-table-column> -->
                <el-table-column
                    label="操作"
                    width="100"
                >
                    <template slot-scope="scope">
                        <el-button class="table-column-btn" type="text" icon="el-icon-search"  @click="toDetails(scope.row)"></el-button>                         
                        <!-- <el-button  v-if='scope.row.blEnjoin==0' class="table-column-btn" type="text" icon="el-icon-star-off"  @click="collect_click(scope.row,'add')"></el-button>            
                        <el-button  v-if='scope.row.blEnjoin==1' class="table-column-btn" type="text" icon="el-icon-star-on"  @click="collect_click(scope.row,'cancel')"></el-button>                
                        <el-button v-if='scope.row.blAnalysis==0'  class="table-column-btn" type="text" icon="el-icon-circle-plus-outline"  @click="analysis_click(scope.row,'add')"></el-button>
                        <el-button v-if='scope.row.blAnalysis==1' class="table-column-btn" type="text" icon="el-icon-circle-plus"  @click="analysis_click(scope.row,' cancel')"></el-button> -->
                    </template>
                </el-table-column>
                
            </el-table>
            <el-pagination 
                size='small'
                class="page-wrap"  
                @current-change="changePage" 
                @size-change="sizeChange"
                background
                :current-page="pageInfo.pageNum" 
                :page-count="pageInfo.pageTotal" 
                :page-size="pageInfo.pageSize"
                :total="pageInfo.total"
                :page-sizes="[10, 20, 30, 50, 100]" 
                layout="total, sizes, prev, pager, next, jumper"  >
            </el-pagination>
        </div>
        <!-- 消耗提示 -->
        <modelTip :ok="'确定'"  :show.sync="isShowTip" @ok='sure_click()'>
            <div slot="content" >
                <p>将消耗1个积分{{tipVal}}，确定吗？</p>
            </div>
        </modelTip>
         <!-- 批量提示 -->
        <modelTip :ok="'确定'"  :show.sync="isShowBatch" @ok='sure_batch()'>
            <div slot="content" >
                <p>{{ batchTip}}</p>
            </div>
        </modelTip>
        <!-- 公用提示 -->
        <modelTip :ok="'确定'"  :show.sync="isPublic" @ok='public_click'>
            <div slot="content" >
                <p>{{publicTip}}</p>
            </div>
        </modelTip>
         <!-- 加入分析池成功后提示 -->
        <modelTip :ok="'确定'"  :show.sync="analysisAddOk" @ok='analysisAddOk_click'>
            <div slot="content" >
                <p>您已成功加入分析池，可以进行数据挖掘。</p>
            </div>
        </modelTip>
        <!-- 保存选择医案库 -->
	    <!-- <chooseMedicalCollect v-if='libraryDialog' :sourceType="'searchMedical'" :show.sync="libraryDialog"  @save='saveLibraryList'></chooseMedicalCollect> -->
    </div>
</template>

<script>


import { mapState, mapMutations, mapActions } from "vuex";
import modelTip from '../../../components/ui-kit/model_tip.vue'//../../../components/ui-kit/model_tip.vue
// import chooseMedicalCollect from "../../../components/ui-kit/choose_medical_collect.vue"
import {caseGeneralSearch,caseGetSeniorSearch,caseAddAnalysisPool,caseCancelAnalysisPool,caseAddCollect,caseCancelCollect} from '../../../io/api.js'
import {getCookieInfo} from '../../../io/getCookie.js'
export default {
    components: {
        modelTip,
        // chooseMedicalCollect,
         
    }, 
    data () {
        return {
            isShowTip:false,
            isShowBatch:false,
            isPublic:false,
            analysisAddOk:false,
            libraryDialog:false,
            tipVal:'进行查看',
            publicTip:'',
            publicType:'',
            batchTip:'',
            batchClickNum:0,
            keyWord:this.$route.query.keyWord||'',
            keywordSearchType:this.$route.query.keywordSearchType||'',
            leftWord:'',
            leftSort:'', 
            medicalLoading:false,
            tableList:[ ],
            batchDetails:[],
            pageInfo:{
                pageNum: 1,
                pageTotal: 1,
                total: 1,
                pageSize: 10,
            },
            tableRow:{},
            sourceType:this.$route.query.sourceType||'',  
        }
    },
    computed: {  
		...mapState(['hitNum',''])	
	},
    mounted () {
        this.getList();
        // this.getSelfStore_list(); 
        // this.getShouCangJiaList_list(); 
    },
    methods: { 
        // ...mapActions(['getShouCangJiaList_list']),
        getList(leftWord,leftSort,keyWord,searchName){ 
            //切换分页的时候需要
            this.leftWord=leftWord||this.leftWord||'';
            this.leftSort=leftSort||this.leftSort||'';
            this.keyWord =keyWord?keyWord:this.keyWord;
             this.getAdvanced_list(this.leftWord,this.leftSort)
            // if(this.sourceType=='advanced'){
            //     //高级检索 
            //     this.getAdvanced_list(this.leftWord,this.leftSort)
            // }else{
            //     //普通检索
            //     this.getSerch_list(this.leftWord,this.leftSort,this.keyWord,searchName); 
            // }
            
        },
        //普通检索 
        /*
            searchName线上查询的时候knowledgeSearch值是查询的value;
            keyword每次查询的时候都要keyword+searchName,在上个页面已经处理过了;
        */
        getSerch_list(leftWord,leftSort,keyWord,searchName){
            this.medicalLoading = true; 
            let params={
                pageIndex: this.pageInfo.pageNum.toString()||'1',
                keyword: keyWord||'',
                leftSort:leftSort||'',
                leftWord:leftWord||'',
                // totalNum:'',
                keywordSearchStore:'',
                knowledgeSearch:searchName||'',
                // searchMechanismName: '中国中医科学院', 
                keywordSearchType: this.keywordSearchType,
            }   
            caseGeneralSearch(params).then(res=>{
                let data = res.data; 
                if(data&&data.code==0){
                    this.tableList = data.data.list;
                    this.pageInfo.total = Number(data.data.totalCount);
                    this.pageInfo.pageTotal = Number(data.data.totalPage);
                }else{
                    this.$message.error( data.msg||'请求失败～')
                }
                this.medicalLoading = false;
            })  
            
        },
        //高级检索
        getAdvanced_list(leftWord,leftSort){
            this.medicalLoading = true; 
            let highSearchWord = window.localStorage.getItem("highSearchWord")||getCookieInfo('highSearchWord')||'';
            let yianku=this.$route.query.medicalLibraryId.split(";");
            let params={
                page: this.pageInfo.pageNum.toString()||'1', 
                leftSort:leftSort||'',
                leftWord:leftWord||'',
                yianku:JSON.stringify(yianku), 
                // highSearchWord: JSON.parse(highSearchWord) , 
                highSearchWord,
                // totalNum: '' ,
                limit: this.pageInfo.pageSize, 
                // searchMechanismName: '',
                // keywordSearchType: 1,
            }    
            // caseGetSeniorSearch(params) 
            this.$http.post(`/ckcest/consilia/highSearch`,params).then(res=>{
                let data = res.data; 
                if(data&&data.code==0){
                    this.tableList = data.page.list;
                    this.pageInfo.total = Number(data.page.totalCount);
                    this.pageInfo.pageTotal = Number(data.page.totalPage);
                }else{
                    this.$message.error( data.msg||'请求失败～')
                }
                this.medicalLoading = false;
            })  
        },
        initData(){
            this.batchDetails=[];
            this.pageInfo={
                pageNum: 1,
                pageTotal: 1,
                total: 1,
                pageSize: 10,
            }
        }, 
        /*批量相关操作==========*/
        selectChange(val){  
            this.batchDetails=val;
            this.batchIds(val)
        }, 
        // ids拼接
        batchIds(arr){
            let ids =[];
            let num=0;
            arr&&arr.forEach(item => {
                ids.push(item.id) 
                if(item.blClick==0){
                    num++;
                }
            });  
            this.batchClickNum = num;
            this.listId = ids.toString();
        },
        //批量分析池
        batch_analysis(type){ 
            if(this.batchDetails.length==0){
                this.$message.error( '请选择记录！' );
                return
            }else{
                this.batchType=type;
                this.isShowBatch = true;
                if(this.batchType=='analysis_add'){
                    if(this.batchClickNum==0){
                        //为确保数据挖掘功能正常使用，请优先加入收藏夹执行标准化。
                        this.batchTip=`您确定要将选中医案加入分析池么？`
                         
                    }else{
                        //为确保数据挖掘功能正常使用，请优先加入收藏夹执行标准化。
                        this.batchTip=`本次操作将消耗${this.batchClickNum}个积分加入分析池，确定吗？`
                    }
                }else{
                    this.batchTip=`确定取消加入分析池吗？`
                }
            }
        },
        //加入分析池
        add_analysis(params){
            // delete params.storeId
            caseAddAnalysisPool(params).then(res=>{
                let data = res.data
                if(data&&data.code==0){
                    this.analysisAddOk=true;
                    // this.$message({
                    //     message:'加入分析池成功！',
                    //     duration: 1000,
                    //     type: 'success',
                    //         onClose:()=>{
                    //             //您已成功加入分析池，可以进行数据挖掘。
                    //         }
                    //     });
                    this.$store.state.hitNum=Number(this.$store.state.hitNum)-Number(this.batchClickNum);
                    this.getList()
                }else{
                    this.$message.error( data.msg||'请求失败' );
                }
                this.isPublic = false;
            })
        },
        //加入分析池成功提示弹层
        analysisAddOk_click(){
            this.analysisAddOk=false;
        },
        //取消加入分析池
        cancel_analysis(params){ 
            caseCancelAnalysisPool(params).then(res=>{
                let data = res.data
                if(data&&data.code==0){
                    this.$message({
                        message:'取消加入分析池成功！',
                        duration: 1000,
                        type: 'success',
                            onClose:()=>{
                        }
                    });
                    this.getList()
                }else{
                    this.$message.error( data.msg||'请求失败' );
                }
                this.isPublic = false;
            })
        },
        //批量收藏夹
        batch_favorites(type){
            if(this.batchDetails.length==0){
                this.$message.error( '请选择记录！' );
                return
            }else{ 
                this.batchType=type;
                
                this.isShowBatch = true;
                if(this.batchType=='favorites_add'){
                    if(this.batchClickNum==0){
                        this.sure_batch();
                        return
                    }else{
                        this.batchTip=`将消耗${this.batchClickNum}个积分加入收藏夹，确定吗`
                    }
                    
                }else{
                    this.batchTip=`确定取消加入收藏夹吗？`
                }
               
            }
        },
        //加入收藏夹
        add_collect(params,type){ 
            caseAddCollect(params).then(res=>{
                let data = res.data
                if(data&&data.code==0){
                    //type单条操作
                    this.isPublic = true
                    this.publicType='add_success'
                    this.publicTip=`已将${this.batchDetails.length==0?1:this.batchDetails.length}条医案添加至收藏夹，建议标准化后进行数据挖掘分析`
                    this.$store.state.hitNum=Number(this.$store.state.hitNum)-Number(this.batchClickNum);
                    
                    this.getList()
                }else{
                    this.$message.error( data.msg||'请求失败' );
                }
            })
        },
        //取消加入收藏夹
        cancel_collect(params){ 
            caseCancelCollect(params).then(res=>{
                let data = res.data
                if(data&&data.code==0){
                    this.$message({
                        message:'取消加入收藏夹成功！',
                        duration: 1000,
                        type: 'success',
                            onClose:()=>{
                        }
                    });
                    this.getList();
                }else{
                    this.$message.error( data.msg||'请求失败' );
                }
                this.isPublic = false;
            })
        },
        //批量弹层提示
        sure_batch(){
            this.isShowBatch=false;
            let params={
                ids:this.listId, 
                keyword:this.keyWord,//2024.05.24后台日志需要
            }
            if(this.batchType=='analysis_add'){
                this.add_analysis(params)
            }else if(this.batchType=='analysis_cancel'){
                this.cancel_analysis(params)
            }else if(this.batchType=='favorites_add'){
                this.libraryDialog = true; 
                //this.add_collect(params)
            }else if(this.batchType=='favorites_cancel'){
                this.cancel_collect(params)
            }
        },
         /*批量相关操作========end==*/



        //查看详情页
        toDetails(row){   
            console.log(row,'===rowD')
            if(row.blClick==0){
                this.setTipVal('进行查看',row)
                //searchDetails
            }else{
                this.toSearchDetails(row)
            }
        },
         //单条数据收藏夹操作
        collect_click(row,type){ 
            this.publicType = type; 
            this.listId=row.id; 
            this.batchDetails=[].concat(row.id)
            if(type=='add'){ 
                if(row.blClick==0){
                    this.setTipVal('加入收藏夹',row) 
                }else{
                    this.libraryDialog = true; 
                }
            }else{
                this.isPublic = true;
                this.publicType='sure_favorites_cancel'
                this.publicTip='您确定要取消收藏么？'
            }
            //消耗积分后选择医案库，//   
        },
        //单条数据分析池操作
        analysis_click(row,type){ 
            this.listId=row.id;
            this.batchDetails=[].concat(row.id)
            if(type=='add'){ 
                if(row.blClick==0){
                    this.setTipVal('加入分析池',row) 
                }else{
                    this.isPublic = true;
                    this.publicType='sure_analysis_add'
                    this.publicTip='您确定要加入分析池么？'
                }
            }else{
                this.isPublic = true;
                this.publicType='sure_analysis_cancel'
                this.publicTip='您确定要取消加入分析池么？'
            }  
        },
        setTipVal(val,row){
            this.tableRow=row?row:{};
            this.tipVal = val
            this.isShowTip = true;
        },
        //保存医案库
        saveLibraryList(id){ 
            this.libraryDialog = false; 
            let params={
                storeId:id,
                ids:this.listId,
                keyword:this.keyWord
            }
            this.add_collect(params,1) 
        },
        //公用确定
        public_click(){ 
            let params={
                ids:this.listId,
                keyword:this.keyWord
            }
            if(this.publicType =='sure_favorites_cancel'){ 
                this.cancel_collect(params)
            }else if(this.publicType =='sure_analysis_cancel'){
                this.cancel_analysis(params)
            }else if(this.publicType =='sure_analysis_add'){
                this.add_analysis(params)
            }else{
                this.isPublic = false;
            }
        },
        //确定消耗积分
        sure_click(){ 
            //剩余积分
            this.$store.state.hitNum-=1;
            if(this.tipVal =='进行查看'){
                 this.toSearchDetails(this.tableRow);
            }else if(this.tipVal =='加入收藏夹'){
                this.libraryDialog = true;
            }else if(this.tipVal =='加入分析池'){
                this.add_analysis({ids:this.listId})
            }
            this.isShowTip=false; 
            //确定消耗积分后，改变当前数据状态
            this.tableList&&this.tableList.forEach(item=>{
                if(item.id==this.tableRow.id){
                    item.blClick="1";
                }
            })
            
        },
        //检索详情
        toSearchDetails(row){
            let url = this.$router.resolve({
                path:'searchDetails',  
                query:{
                    id:row.id,
                    type:'searchPage',
                    keyWord:this.keyWord,
                }
            })  
			window.open(url.href, '_blank') 
 
        }, 

        
        changePage(num) {
            this.pageInfo.pageNum=num; 
            this.getList(this.leftWord,this.leftSort,this.keyword);
        },
        sizeChange(val) { 
            this.changePage(1)
            this.pageInfo.pageSize=val;
        },
    }
}
</script>

<style lang="less" scoped>
.page-wrap{
    margin-top: 20px;
}
</style>